import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Input, Button, Divider, message } from 'antd';
import store from 'store';

import './PhoneLogin.styl';
import { sendMobileCode, graphicVerificationCode } from '@/api/login';
import { userTenantLogin } from '@/api/tenant';
import { hrefHomeByToken } from '@/utils/util';
import PhoneCode from '@/assets/images/phone-code.png';
import PhoneNum from '@/assets/images/phone-num.png';
import CaptchaCode from '@/assets/images/captcha-code.png';

class PhoneLogin extends Component {
  state = {
    visible: false,
    validCodeRequired: false, // 是否要填写验证码
    visibleDefaultPassword: false,
    loading: false,
    mobile: '',
    mobileCode: '',
    code: '',
    downNum: 0,
    captchaCode: '',
    uuid: '',
    timeoutSer: null,
    propsKeyDownNum: null,
  };
  render() {
    const { downNum, loading, captchaCode, mobile, mobileCode, code } = this.state;
    return (
      <div className="phone-login">
        <Input
          placeholder="请输入注册手机号"
          className="input-back"
          prefix={<img alt="logo" className="phone-icon" src={PhoneNum} />}
          value={mobile}
          onChange={this.changeAccount}
        />

        <Input
          className="input-back m-t-10"
          placeholder="请输入数字校验码"
          prefix={<img alt="logo" className="phone-icon" src={CaptchaCode} />}
          suffix={
            <>
              <Divider type="vertical" className="divider-vertical" />
              <img
                src={captchaCode}
                alt=""
                className="captcha-code"
                onClick={() => this.getCaptchaCode()}
              />
            </>
          }
          value={code}
          onChange={this.changeCaptchaCode}
        />

        <Input
          className="input-back m-t-10"
          placeholder="请输入短信验证码"
          prefix={<img alt="logo" className="phone-icon" src={PhoneCode} />}
          suffix={
            <>
              <Divider type="vertical" className="divider-vertical" />
              {downNum ? (
                <span className="selected pointer phone-code">
                  {`${downNum}s重新发送`}
                </span>
              ) : (
                <span
                  className="selected pointer phone-code"
                  onClick={() => this.getPhoneCode()}
                >
                  获取验证码
                </span>
              )}
            </>
          }
          value={mobileCode}
          onChange={this.changeCode}
        />
        <Button
          type="primary"
          className="login-btn"
          loading={loading}
          onClick={this.handlePhoneLogin}
        >
          登录
        </Button>
      </div>
    );
  }

  // downNum变量60秒倒计时
  handleDownNum() {
    const { downNum } = this.state;
    if (downNum > 0) {
      this.setState({
        downNum: downNum - 1,
      });
      const timeoutSer = setTimeout(() => {
        this.handleDownNum();
      }, 1000);
      this.setState({
        timeoutSer,
      });
    }
  }

  handleOk() {}

  handleCancel() {
    this.setState({
      isModalOpen: false,
    });
  }

  async getCaptchaCode() {
    try {
      const { uuid, image: captchaCode } = await graphicVerificationCode();
      this.setState({
        captchaCode,
        uuid,
        mobileCode: '',
        code: '',
      });
    } catch (e) {
      message.warning(e.message || '');
    }
  }

  // 获取手机号验证码
  getPhoneCode() {
    // 正则判断手机号是否正确
    const { mobile, downNum, code, uuid } = this.state;
    if (downNum > 0) return;
    const reg = /^1[3-9]\d{9}$/;
    if (!reg.test(mobile)) {
      message.warning('请输入完整手机号');
      return;
    }
    if (!code) return message.warning('请输入数字校验码');

    // 倒计时
    this.setState(
      {
        downNum: 60,
      },
      () => {
        this.handleDownNum();
      },
    );
    // 获取code
    sendMobileCode({
      mobile: mobile,
      graphVerifyCode: code,
      uuid,
    })
      .then((res) => {
      })
      .catch((e) => {
        window.clearTimeout(this.state.timeoutSer);
        setTimeout(() => {
          this.setState({
            timeoutSer: null,
            loading: false,
            downNum: 0,
          });
        });
        this.getCaptchaCode();
        message.error(e.message);
      });
  }

  // 手机号
  changeAccount = ({ target: { value } }) => {
    this.setState({
      mobile: value,
    });
  };

  // password改变
  changeCode = ({ target: { value } }) => {
    this.setState({
      mobileCode: value,
    });
  };

  // 防水码
  changeCaptchaCode = ({ target: { value } }) => {
    this.setState({
      code: value,
    });
  };

  /**
   * 账号密码登录
   */
  handlePhoneLogin = async () => {
    const { mobileCode, mobile, code } = this.state;

    const reg = /^1[3-9]\d{9}$/;
    if (!reg.test(mobile)) return message.warning('请输入完整手机号');
    if (!code) return message.warning('请输入数字校验码');
    if (!mobileCode) return message.warning('请输入正确验证码');
    this.setState({ loading: true });

    userTenantLogin({
      grantType: 'mobile',
      mobile,
      mobileCode,
    })
      .then((res) => {
        const { token, bizOrgList, userIdentity } = res;
        this.setState({ loading: false });
        if (token && token.access_token) {
          hrefHomeByToken(
            token.access_token,
            bizOrgList,
            userIdentity,
            this.props.history,
          );
        } else {
          const messageInfo = res.message;
          store.clearAll();
          message.error(messageInfo);
        }
      })
      .catch((e) => {
        store.clearAll();
        this.setState({ loading: false });
        message.error(e.message || '登录失败');
      });
  };

  // 父级window监听键盘回车事件
  componentWillReceiveProps({ propsKeyDownNum, checkIndex }) {
    if (checkIndex === 1 && propsKeyDownNum && this.state.propsKeyDownNum !== propsKeyDownNum) {
      this.state.propsKeyDownNum = propsKeyDownNum;
      this.handlePhoneLogin()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.checkIndex !== this.props.checkIndex && this.props.checkIndex === 1) {
      this.getCaptchaCode();
    }
  }
}

export default withRouter(PhoneLogin);
